import { render, staticRenderFns } from "./Helpdoc.vue?vue&type=template&id=4e5defd0"
import script from "./Helpdoc.vue?vue&type=script&lang=js"
export * from "./Helpdoc.vue?vue&type=script&lang=js"
import style0 from "./Helpdoc.vue?vue&type=style&index=0&id=4e5defd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports